/** The grades of a live pool in order, as the grade bar draws them. */

import type { GradeCounts, LiveGrade } from './types';

export const GRADES: Array<{ grade: LiveGrade; key: keyof Omit<GradeCounts, 'ungraded'>; className: string }> = [
	{ grade: 'Perfect', key: 'perfect', className: 'fill-green-600' },
	{ grade: 'Good Enough', key: 'goodEnough', className: 'fill-green-300' },
	{ grade: 'Incomplete', key: 'incomplete', className: 'fill-amber-500' },
	{ grade: 'Incorrect', key: 'incorrect', className: 'fill-red-600' }
];

export const gradedCount = (grades: GradeCounts): number =>
	grades.perfect + grades.goodEnough + grades.incomplete + grades.incorrect;
